import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import Cookie from 'js-cookie'

import storage from '@/utils/storage'

import AuthService from '@/features/auth/auth.service'
import { axios } from '@/lib/axios'

export const loginWithEmail = createAsyncThunk('auth/login', async ({ email, password }, thunkAPI) => {
  try {
    const res = await AuthService.loginWithEmailAndPassword({ email, password })
    return { user: res.data }
  } catch (e) {
    return thunkAPI.rejectWithValue({ error: e.response.data })
  }
})

export const loadMe = createAsyncThunk('auth/loadme', async (_, thunkAPI) => {
  // Load Me is the first step the app will do to determin current user valid token
  try {
    const res = await axios.get('/auth/me')

    return { user: res.data }
  } catch (e) {
    console.log('Error', e.response.data)
    return thunkAPI.rejectWithValue({ error: e.response.data })
  }
})

export const loginWithSiemensID = createAsyncThunk('auth/siemensid/token', async ({ code }, thunkAPI) => {
  try {
    const res = await AuthService.loginWithSiemensID({ code, source: 'internal' })
    return { user: res.data }
  } catch (e) {
    return thunkAPI.rejectWithValue({ error: e.response.data })
  }
})

const initialState = {
  appLoaded: false,
  isAuthenticated: false,
  isLoading: false,
  errorMessage: '',
  error: null,
  user: null,
  token: storage.getToken(),
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearState: (state) => {
      state.isLoading = false

      return state
    },
    initAuth: (state) => {
      state.appLoaded = true
      state.isLoading = false
      state.isAuthenticated = false

      return state
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload
      return state
    },
    setUser: (state, action) => {
      if (action.payload) {
        state.user = action.payload
        state.isAuthenticated = true
      }
      return state
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      state.error = null
      state.isLoading = false
      storage.clear()
      Cookie.remove('x-auth-cookie')

      // Clear announcement session storage
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('announcement_shown_')) {
          sessionStorage.removeItem(key)
        }
      })
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loadMe.pending, (state) => {
        state.isLoading = true
        state.appLoaded = false
        state.error = null
      })
      .addCase(loadMe.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.appLoaded = true
        state.isAuthenticated = true
        state.user = payload.user
        state.error = null
      })
      .addCase(loadMe.rejected, (state) => {
        // Remove Token as it maybe expired
        storage.clear()
        state.isLoading = false
        state.appLoaded = true
        state.isAuthenticated = false
        state.user = null

        // state.error = payload.error;
      })
      .addCase(loginWithEmail.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(loginWithEmail.fulfilled, (state) => {
        state.isLoading = false
        state.isAuthenticated = true
        state.error = null
      })
      .addCase(loginWithEmail.rejected, (state, { payload }) => {
        console.log('payload', payload)
        state.isLoading = false
        state.error = payload.error
        state.user = null
        state.isAuthenticated = false
      })
  },
})

export const { clearState, setIsAuthenticated, setUser, logout, initAuth } = authSlice.actions

export default authSlice.reducer

export const authSelector = (state) => state.auth
